export const toFixed = (num) => {
  if (typeof num === 'number' && num.toFixed) {
    return num.toFixed(2);
  }
  return '0.00';
};
